/**
 * Generate dynamic page size options based on total items
 */
export const getPageSizeOptions = (totalItems: number): number[] => {
  // Always show 10 as minimum option
  if (totalItems <= 10) {
    return [10];
  }

  // Show relevant options based on total items
  if (totalItems <= 25) {
    return [10, 25];
  }

  if (totalItems <= 50) {
    return [10, 25, 50];
  }

  // For 50+ items, show all options
  return [10, 25, 50, 100];
};
